import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getLoadingMatch = store => store[NAME].isLoadingMatch;
export const getData = store => store[NAME].data;
export const getEmployees = store => store[NAME].employees;
export const getAccumulators = store => store[NAME].accumulators;

export const getTemplatesRows = store => store[NAME].templates;
export const getLoadingTemplates = store => store[NAME].isLoadingTemplates;